module.exports = __webpack_public_path__ + "static/media/demo-screen-1.0f6126a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/images/demo-screen-1.jpg
// module id = 117
// module chunks = 0